import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';
import '../styles.css';

const FiltersAccordionGroupDatePicker = props => {
  const { title, selected, group, disabled, onChange } = props;

  const currentDate = new Date();
  const selectedDate = selected ? Date.parse(selected) : null;

  const appendLeadingZeroes = n => (n <= 9 ? `0${n}` : n);

  const handleChange = value => {
    const date =
      value.getFullYear() +
      '-' +
      appendLeadingZeroes(value.getMonth() + 1) +
      '-' +
      appendLeadingZeroes(value.getDate());
    onChange(group, date);
  };

  return (
    <>
      <div className="filter-group__datepicker">
        {title && <span className="filter-group__title">{title}</span>}
        <DatePicker
          selected={selectedDate}
          dateFormat={'yyyy-MM-dd'}
          maxDate={currentDate}
          disabled={disabled}
          onChange={handleChange}
        />
      </div>
    </>
  );
};

FiltersAccordionGroupDatePicker.defaultProps = {
  onChangeFunc: () => {},
  elements: [],
};

FiltersAccordionGroupDatePicker.propTypes = {
  onChangeFunc: PropTypes.func,
  elements: PropTypes.array,
};

export default FiltersAccordionGroupDatePicker;
